document.addEventListener("DOMContentLoaded", function () {
  const API_BASE = "https://shopify-inksoft-poc-dag7ggedh5c9cacb.westus2-01.azurewebsites.net/api/poc";

  const categoriesContainer = document.getElementById("categories-container");
  const productsContainer = document.getElementById("products-container");
  const statusEl = document.getElementById("poc-status");
  const productsHeading = document.getElementById("products-heading");

  if (!categoriesContainer || !productsContainer || !statusEl || !productsHeading) {
    return;
  }

  function setStatus(message) {
    statusEl.textContent = message;
  }

  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function getProductImage(product) {
    const style0 = product?.Styles?.[0];
    const side0 = style0?.Sides?.[0];

    const path =
      style0?.ImageFilePath_Front ||
      style0?.ImageFilePath ||
      side0?.ImageFilePath ||
      "";

    if (!path) return "";

    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }

    return `https://shop.unisourceapparel.com${path}`;
  }

  function renderProducts(products, categoryName) {
    productsHeading.textContent = `Products for ${categoryName}`;
    productsContainer.innerHTML = "";

    if (!Array.isArray(products) || products.length === 0) {
      productsContainer.innerHTML = `
        <div class="product-empty">No products found for ${escapeHtml(categoryName)}.</div>
      `;
      setStatus(`No products found for ${categoryName}.`);
      return;
    }

    const cardsHtml = products.map((product) => {
      const title = product?.Name || "Unnamed Product";
      const sku = product?.Sku || "N/A";
      const supplier = product?.Supplier || "N/A";
      const manufacturer = product?.Manufacturer || "N/A";
      const image = getProductImage(product);

      return `
        <article class="product-card">
          <div class="product-card__image-wrap">
            ${
              image
                ? `<img class="product-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy">`
                : `<div class="product-card__meta">No image available</div>`
            }
          </div>
          <h3 class="product-card__title">${escapeHtml(title)}</h3>
          <p class="product-card__meta">SKU: ${escapeHtml(sku)}</p>
          <p class="product-card__meta">Supplier: ${escapeHtml(supplier)}</p>
          <p class="product-card__meta">Manufacturer: ${escapeHtml(manufacturer)}</p>
        </article>
      `;
    }).join("");

    productsContainer.innerHTML = cardsHtml;
    setStatus(`Loaded ${products.length} products for ${categoryName}.`);
  }

  async function loadProducts(categoryId, categoryName, clickedButton) {
    try {
      setStatus(`Loading products for ${categoryName}...`);
      productsContainer.innerHTML = "";

      document.querySelectorAll(".category-button").forEach((btn) => {
        btn.classList.remove("is-active");
      });

      if (clickedButton) {
        clickedButton.classList.add("is-active");
      }

      const response = await fetch(`${API_BASE}/products/by-category?category=${encodeURIComponent(categoryId)}`, {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Products request failed: ${response.status}`);
      }

      const json = await response.json();
      renderProducts(json?.data || [], categoryName);
    } catch (error) {
      console.error("Error loading products:", error);
      productsHeading.textContent = `Products for ${categoryName}`;
      productsContainer.innerHTML = `
        <div class="product-error">Unable to load products for ${escapeHtml(categoryName)}.</div>
      `;
      setStatus(`Product load failed for ${categoryName}.`);
    }
  }

  async function loadCategories() {
    try {
      setStatus("Loading categories...");
      categoriesContainer.innerHTML = "";

      const response = await fetch(`${API_BASE}/categories`, {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Categories request failed: ${response.status}`);
      }

      const json = await response.json();
      const categories = Array.isArray(json?.data) ? json.data : [];

      if (categories.length === 0) {
        categoriesContainer.innerHTML = `<div class="product-empty">No categories found.</div>`;
        setStatus("No categories found.");
        return;
      }

      categories.forEach((category, index) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "category-button";
        btn.textContent = `${category.name} (${category.itemCount ?? 0})`;

        btn.addEventListener("click", function () {
          loadProducts(category.id, category.name, btn);
        });

        categoriesContainer.appendChild(btn);

        if (index === 0) {
          loadProducts(category.id, category.name, btn);
        }
      });

      setStatus(`Loaded ${categories.length} categories.`);
    } catch (error) {
      console.error("Error loading categories:", error);
      categoriesContainer.innerHTML = `<div class="product-error">Unable to load categories.</div>`;
      setStatus("Category load failed.");
    }
  }

  loadCategories();
});